import { useAtom } from "jotai";
import { StepAtom } from "./atoms";
export enum steps {
  Step1 = "1",
  Step2 = "2",
  Step3 = "3",
  Step4 = "4",
  StepResult = "results"
}

export const navigationConfig = {
  [steps.Step1]: {
    prev: null,
    next: steps.Step2,
    validate() {
      return true;
    }
  },
  [steps.Step2]: {
    prev: steps.Step1,
    next: steps.Step3,
    validate() {
      return true;
    }
  },
  [steps.Step3]: {
    prev: steps.Step2,
    next: steps.Step4,
    validate() {
      return true;
    }
  },
  [steps.Step4]: {
    prev: steps.Step3,
    next: steps.StepResult,
    validate() {
      return true;
    }
  },
  [steps.StepResult]: {
    prev: steps.Step4,
    next: null,
    validate() {
      return true;
    }
  }
};
export function useNav() {
  const [step, setStep] = useAtom(StepAtom);
  return {
    next() {
      if (navigationConfig[step].next != null) {
        if (navigationConfig[step].validate()) {
          setStep(navigationConfig[step].next);
        }
      }
    },
    prev() {
      if (navigationConfig[step].prev != null) {
        setStep(navigationConfig[step].prev);
      }
    }
  };
}
